<template>
  <!-- Una pastilla con el color actual que abre el selector de Vuetify. Se
       usa en el alta y en la edicion de etiquetas. -->
  <v-menu v-model="open" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="on"
        label
        :disabled="disabled"
        :color="background"
        :text-color="textColor"
        class="tag-color-picker__chip"
      >
        <v-icon small left>palette</v-icon>
        {{ value ? value : "Sin color" }}
      </v-chip>
    </template>
    <v-card>
      <v-color-picker
        :value="value || defaultColor"
        mode="hexa"
        hide-mode-switch
        flat
        @input="onInput"
      />
      <v-card-actions>
        <v-btn text small @click="clear">Sin color</v-btn>
        <v-spacer />
        <v-btn text small color="primary" @click="open = false">Listo</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
"use strict";

import { DEFAULT_TAG_COLOR, textColorFor } from "@/utils/tag-color";

export default {
  name: "tag-color-picker",
  props: {
    // '#RRGGBB' o '' (sin color).
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { open: false, defaultColor: DEFAULT_TAG_COLOR };
  },
  computed: {
    background() {
      return this.value || DEFAULT_TAG_COLOR;
    },
    textColor() {
      return textColorFor(this.background);
    }
  },
  methods: {
    // v-color-picker en modo hexa devuelve '#RRGGBBAA'; el alfa no se guarda.
    onInput(hexa) {
      const hex = String(hexa || "").slice(0, 7).toUpperCase();
      if (hex !== this.value) this.$emit("input", hex);
    },
    clear() {
      this.$emit("input", "");
      this.open = false;
    }
  }
};
</script>

<style lang="scss">
.tag-color-picker__chip {
  cursor: pointer;
}
</style>
